import * as React from "react";
const SvgFiRrFee = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M7 6.5a1.5 1.5 0 1 1-3.001-.001A1.5 1.5 0 0 1 7 6.5M5.5 12a1.5 1.5 0 1 0 .001 3.001A1.5 1.5 0 0 0 5.5 12M20 6.5a1.5 1.5 0 1 0-3.001.001A1.5 1.5 0 0 0 20 6.5M16 10c0 2.206-1.794 4-4 4s-4-1.794-4-4 1.794-4 4-4 4 1.794 4 4m-2 0c0-1.103-.897-2-2-2s-2 .897-2 2 .897 2 2 2 2-.897 2-2m5-8H5C2.243 2 0 4.243 0 7v6c0 2.757 2.243 5 5 5h7a1 1 0 1 0 0-2H5c-1.654 0-3-1.346-3-3V7c0-1.654 1.346-3 3-3h14c1.654 0 3 1.346 3 3v5a1 1 0 1 0 2 0V7c0-2.757-2.243-5-5-5m3.5 19a1.5 1.5 0 1 0 .001 3.001A1.5 1.5 0 0 0 22.5 21M18 16.5a1.5 1.5 0 1 0-3.001.001A1.5 1.5 0 0 0 18 16.5m4.291-1.341a.997.997 0 0 0-1.382.3l-4.5 7a1 1 0 1 0 1.682 1.082l4.5-7a1 1 0 0 0-.3-1.382"
    />
  </svg>
);
export default SvgFiRrFee;
